import React from "react";
import useStyles from "./styles";

export default function OrderBox(props) {
  const classes = useStyles();

  // Function to get status configuration
  const getStatusConfig = (orderStatus) => {
    const statusConfig = {
      "Delivered": {
        className: classes.statusDelivered,
        icon: "fa-check-circle"
      },
      "Dispatched": {
        className: classes.statusDispatched,
        icon: "fa-truck"
      },
      "Ready to Dispatch": {
        className: classes.statusReadyToDispatch,
        icon: "fa-archive"
      },
      "Processing": {
        className: classes.statusProcessing,
        icon: "fa-cog"
      },
      "Confirmed": {
        className: classes.statusConfirmed,
        icon: "fa-check"
      },
      "Cancelled": {
        className: classes.statusCancelled,
        icon: "fa-times-circle"
      },
      "Refunded": {
        className: classes.statusRefunded,
        icon: "fa-undo"
      },
      "Return Initiated": {
        className: classes.statusReturnInitiated,
        icon: "fa-arrow-left"
      },
      "Return Received": {
        className: classes.statusReturnReceived,
        icon: "fa-undo"
      },
      "On Hold": {
        className: classes.statusOnHold,
        icon: "fa-pause"
      },
      "Pending": {
        className: classes.statusPending,
        icon: "fa-clock-o"
      }
    };

    return statusConfig[orderStatus] || statusConfig["Pending"];
  };

  const openModal = () => {
    props.handleOpen();
    props.setOrder(props.product);
    props.setOrderAmount(props.product.item_amount);
  }
  return (
    <div className={classes.orderCard}>
      <div
        onClick={openModal}
        className={classes.orderCardContent}
      >
        <div className={classes.orderHeader}>
          <div className={classes.orderInfo}>
            <div className={classes.orderIdSection}>
              <span className={classes.orderIdLabel}>Order ID</span>
              <span className={classes.orderIdValue}>#{props.product.order_id}</span>
            </div>
            <div className={classes.orderDate}>
              <i className="fa fa-calendar"></i>
              <span>{props.product.order_date}</span>
            </div>
          </div>
          <div className={classes.orderStatus}>
            {(() => {
              const statusConfig = getStatusConfig(props.product.order_status);
              return (
                <div className={`${classes.statusBadge} ${statusConfig.className}`}>
                  <i className={`fa ${statusConfig.icon}`}></i>
                  <span>{props.product.order_status}</span>
                </div>
              );
            })()}
          </div>
        </div>

        <div className={classes.orderBody}>
          <div className={classes.orderAmountSection}>
            <div className={classes.amountLabel}>Total Amount</div>
            <div className={classes.amountValue}>
              <i className="fa fa-inr"></i>
              {props.product.item_amount}
            </div>
          </div>
          
          <div className={classes.orderActions}>
            <div className={classes.viewDetails}>
              <span>View Details</span>
              <i className="fa fa-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
